import styles from './styles';

// Projections
const projDefinitions = {
	epsg5514:
		'+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +towgs84=589,76,480,0,0,0,0 +units=m +no_defs',
};

export default {
	projDefinitions,
	...styles,
};
